import React from "react";
import { Box, Typography, Divider, Pagination } from "@mui/material";
import { CardsWrapper } from "./styles";
import { formatDate } from "../../../../utils/formatDate";
import { formatCurrency } from "../../../../utils/formatCurrency";
import { AffiliateTransfer } from "../../../../store/services/affiliate/dto/affiliate.dto";

const AffiliateTransfersCardsList = ({
	data,
	onCardClick,
	page,
	perPage,
	totalItems,
	onPageChange
}: {
	data: AffiliateTransfer[];
	onCardClick: (transfer: AffiliateTransfer) => void;
	page?: number;
	perPage?: number;
	totalItems?: number;
	onPageChange?: (page: number) => void;
}) => {
	return (
		<CardsWrapper>
			{(data || []).map(item => (
				<Box key={item.id} className={"card"} onClick={() => onCardClick(item)}>
					<Box my={1} display={"flex"} justifyContent={"space-between"} alignItems={"center"} px={1}>
						<Typography fontWeight={"bold"}>{item.reference}</Typography>
					</Box>
					<Divider />
					<Box p={1} pb={0} display={"flex"} flexDirection={"column"} gap={1}>
						<Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
							<Box display={"flex"} flexDirection={"column"} alignItems={"flex-start"} gap={1}>
								<Typography fontWeight={"bold"}>Total Sales</Typography>
								<Typography>{formatCurrency(item.totalSales, "EGP")}</Typography>
							</Box>
							<Box display={"flex"} flexDirection={"column"} alignItems={"flex-start"} gap={1}>
								<Typography fontWeight={"bold"}>Amount Transferred</Typography>
								<Typography>{formatCurrency(item.totalCommission, "EGP")}</Typography>
							</Box>
						</Box>
						<Divider />
						<Box className={"card-footer"}>
							<Typography variant={"caption"} color={"textSecondary"}>
								{item.paidAt ? formatDate(item.paidAt, "Africa/Cairo", "PP") : "-"}
							</Typography>
						</Box>
					</Box>
				</Box>
			))}
			{!!(page && perPage && totalItems) && (
				<Box p={2} display={"flex"} justifyContent={"flex-end"}>
					<Pagination
						page={page}
						count={Math.ceil(totalItems / perPage)}
						shape="rounded"
						onChange={(event: unknown, newPage: number) => {
							onPageChange && onPageChange(newPage);
						}}
					/>
				</Box>
			)}
		</CardsWrapper>
	);
};

export default AffiliateTransfersCardsList;
